import * as React from "react"
import {Place} from "../model/places/PlaceTypes"
import {Loader, Table} from "semantic-ui-react"
import {ID} from "../model/id"
import {Place as PLACE} from "../graphql/queries"
import {GraphQL} from "../graphql"

interface OwnProps {
  placeId: ID
}

type Props = OwnProps & PlaceProp

function PlaceView(props: Props) {
  const {place} = props

  return (
    <Table celled compact="very">
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <b>Name (if any)</b>
          </Table.Cell>
          <Table.Cell>{place.optionalName}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <b>Address</b>
          </Table.Cell>
          <Table.Cell>{place.address}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <b>ID</b>
          </Table.Cell>
          <Table.Cell>{place.id}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  )
}

interface PlaceProp {
  place: Place
}

function WithPlace(props: OwnProps) {
  const {placeId} = props
  return (
    <GraphQL.Query
      query={PLACE}
      variables={{id: placeId}}
      render={({data}) => {
        if (data) {
          return <PlaceView {...props} place={data.place} />
        } else {
          return <Loader active />
        }
      }}
    />
  )
}

export {WithPlace as PlaceView}



// WEBPACK FOOTER //
// ./src/components/PlaceView.tsx